import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { FilterSituationByNamePipe } from 'src/app/shared/pipes/filter-situation-by-name/filter-situation-by-name.pipe';
import { ParametrageModule } from '../parametrage/parametrage.module';
import { ListSituationComponent } from './list-situation/list-situation.component';
import { SituationModalDetailComponent } from './modal/situation-modal-detail/situation-modal-detail.component';
import { SituationModalAjoutComponent } from './modal/situation-modal-ajout/situation-modal-ajout.component';

@NgModule({
	declarations: [
		ListSituationComponent,
		SituationModalDetailComponent,
		SituationModalAjoutComponent
	],
	imports: [SharedModule, ParametrageModule],
	providers: [FilterSituationByNamePipe]
})

export class SituationModule {}
